export default function LogosGrid (props = {
    heading: null,
    items: null
}) {
    const items = Array.isArray(props.items)
        ? props.items
            .filter(obj => obj.title
                && obj.img
                && obj.img.src)
            .map((obj) => {
                obj.img.alt = obj.img.alt
                    || `${obj.title} logo`

                return obj
            })
        : []

    if (!items.length)
        return null

    return (
        <section className="logos-grid pad-section">
            <div className="container">
                {props.heading
                    && (
                        <div className="row flex-justify-content-center margin-4-b margin-5-b-lg-up">
                            <div className="col-12 col-10-lg-up">
                                <h2 className="text-align-center">
                                    {props.heading}
                                </h2>
                            </div>
                        </div>)}
                <ul className="row flex-justify-content-center margin-5-b-neg">
                    {items
                        .map((obj, idx) => (
                            <li
                                className="display-flex col-6 col-4-md col-2-lg-up margin-5-b margin-0-l-lg-down margin-0-r-lg-down"
                                key={`logo-${idx}`}
                                style={{
                                    marginLeft: !(idx % 5)
                                        ? '8.3333%'
                                        : null,
                                    marginRight: idx + 1 === items.length
                                            || !((idx + 1) % 5)
                                        ? '8.3333%'
                                        : null
                                }}
                            >
                                <div className="display-flex flex-justify-content-center margin-auto">
                                    <img
                                        className="display-block"
                                        src={obj.img.src}
                                        alt={obj.img.alt}
                                        width={obj.img.width}
                                        height={obj.img.height}
                                        title={obj.title}
                                        style={{ maxHeight: '70px' }}
                                    />
                                </div>
                            </li>
                        ))}
                </ul>
            </div>
        </section>
    )
}
